import Header from "./components/Header";
import AnimatedRoutes from "./components/AnimatedRoutes";

function App() {
  const personalDetails = {
    name: "Minn Thu Kyaw",
    location: "Yangon, Myanmar",
    email: "kyaw261517@gmail.com",
    availability: "Open for work",
    brand:
      "If money is the bond binding me to human life, binding society to me, connecting me with nature and man, is not money the bond of all bonds? Can it not dissolve and bind all ties? Is it not, therefore, also the universal agent of separation?",
  };

  return (
    <>
      <Header />
      <AnimatedRoutes personalDetails={personalDetails} />
    </>
  );
}

export default App;
